import { Box, Link, DynamicYield, Stack, useSession, Skeleton } from '@packages/shared';
import type { FC } from 'react';
import { useUspData } from './useUspData';

const dynamicIDs = [
  'usp_replace-first-usp',
  'usp_replace-second-usp',
  'usp_replace-third-usp',
  'usp_replace-forth-usp',
];

interface USPLinkProps {
  text: string;
  url: string;
  dynamicID: string;
}

const USPLink: FC<USPLinkProps> = ({ text, url, dynamicID }) => (
  <Box>
    <DynamicYield dataDyId={dynamicID} />
    <Link
      href={url}
      data-testid="usp-link"
      noLinkStyle
      sx={{
        display: 'flex',
        py: 1,
        typography: 'body1',
        fontSize: '0.875rem',
        textAlign: 'center',
      }}
    >
      {text}
    </Link>
  </Box>
);

/**
 * USP are Links under Desktop Navigation
 * It will render links from Array
 * Links are hard coded and should be changed in Config
 */
export const Usp = () => {
  const { jwtToken } = useSession();
  const { data: uspData } = useUspData();
  const links = uspData?.find((item) => (item.title === jwtToken ? 'Angemeldet' : 'Abgemeldet'));

  if (!links) {
    return null;
  }

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{
        maxWidth: 'xl',
        borderBottom: '0.0625rem solid black',
        borderBottomColor: 'grey.light',
      }}
      spacing={2}
    >
      {links.children.map((link, index) => (
        <USPLink
          key={dynamicIDs[index]}
          text={link.translatable_title}
          url={link.translatable_url}
          dynamicID={dynamicIDs[index]}
        />
      ))}
    </Stack>
  );
};

/**
 * Loading fallback for Usp row.
 * Actually used only when component is whithout initial data and is purely CSR.
 * In future the fallback will be used when this component will turn to be a server component
 */
export const UspLoadingFallback = () => (
  <Stack
    sx={{
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
      py: 1,
      height: 36,
      gap: 2,
      span: { flexGrow: 1, height: 20 },
    }}
  >
    <Skeleton variant="rectangular" />
    <Skeleton variant="rectangular" />
    <Skeleton variant="rectangular" />
  </Stack>
);

// TODO: add usp error fallback component
